import { useEffect } from "react";

// Utility function to convert rgb() to hexadecimal
function rgbToHex(rgb) {
  const result = rgb.match(/\d+/g);
  if (!result) return "#000000";
  return (
    "#" + result.map((x) => ("0" + parseInt(x).toString(16)).slice(-2)).join("")
  );
}

// Custom hook that updates the theme color meta tag
const useThemeColor = (selector = ".background", updateInterval = 50) => {
  useEffect(() => {
    const targetElement = document.querySelector(selector);
    if (!targetElement) {
      console.warn(`Element with selector "${selector}" not found.`);
      return;
    }

    function updateThemeColor() {
      const computedStyle = getComputedStyle(targetElement);
      const bgColor = computedStyle.backgroundColor;
      let metaThemeColor = document.querySelector('meta[name="theme-color"]');
      if (metaThemeColor) {
        metaThemeColor.setAttribute("content", rgbToHex(bgColor));
      } else {
        metaThemeColor = document.createElement("meta");
        metaThemeColor.name = "theme-color";
        metaThemeColor.content = rgbToHex(bgColor);
        document.head.appendChild(metaThemeColor);
      }
    }

    const intervalId = setInterval(updateThemeColor, updateInterval);
    return () => clearInterval(intervalId);
  }, [selector, updateInterval]);
};

export default useThemeColor;
